import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityEntidadesProductivaActividadLoadFailure,
  entityEntidadesProductivaActividadLoadRequest,
  entityEntidadesProductivaActividadLoadSuccess
  /* entityEntidadesProductivaActividadAddFailure,
  entityEntidadesProductivaActividadAddRequest,
  entityEntidadesProductivaActividadAddSuccess*/
} from './entity-entidades-productiva-actividad.actions';

import { EntidadesProductivaActividadService } from '@rpe/registro-personas-empresas-lib';

@Injectable()
export class EntidadesProductivaActividadEffects {
  // load
  loadRequestEntidadesProductivaActividad = createEffect(() =>
    this.actions$.pipe(
      ofType(entityEntidadesProductivaActividadLoadRequest),
      mergeMap(() =>
        this.entidadesProductivaActividadService
          .getEntidadesProductivaActividad()
          .pipe(
            map((items) =>
              entityEntidadesProductivaActividadLoadSuccess({ items })
            ),
            catchError((error) =>
              of(entityEntidadesProductivaActividadLoadFailure({ error }))
            )
          )
      )
    )
  );
  /*
  // add
  addRequestEntidadesProductivaActividad = createEffect(() =>
    this.actions$.pipe(
      ofType(entityEntidadesProductivaActividadAddRequest),
      switchMap((action) =>
        this.entidadesProductivaActividadService
          .addEntidadProductivaActividad(action.item)
          .pipe(
            map((item) =>
              entityEntidadesProductivaActividadAddSuccess({ item })
            ),
            catchError((error) =>
              of(entityEntidadesProductivaActividadAddFailure({ error }))
            )
          )
      )
    )
  );

  addSuccessEntidadesProductivaActividad = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityEntidadesProductivaActividadAddSuccess),
        tap(() => this.router.navigate(['']))
      ),
    { dispatch: false }
  );*/

  // change

  // delete

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private entidadesProductivaActividadService: EntidadesProductivaActividadService,
    private router: Router
  ) {
    this.entidadesProductivaActividadService.url = environment.apiUrl;
  }
}
